import { FC } from "react"

import { BLOCK_DEFINITIONS } from "./helpers/blockRegistry"
import { PromotionBlock, PromotionBlockType } from "./types/types"
import { BlockList } from "./BlockList"
import { BlocksToolbar } from "./BlocksToolbar"

type Props = {
  value: PromotionBlock[]
  onChange: (blocks: PromotionBlock[]) => void
}

export const BlocksEditor: FC<Props> = ({ value, onChange }) => {
  const handleAddBlock = (type: PromotionBlockType) => {
    const def = BLOCK_DEFINITIONS[type]
    if (!def) return

    const block = def.create()
    onChange([...value, block])
  }

  const handleUpdateBlock = (id: string, patch: Partial<PromotionBlock>) => {
    onChange(value.map((b) => (b.id === id ? ({ ...b, ...patch } as PromotionBlock) : b)))
  }

  const handleMove = (id: string, direction: "up" | "down") => {
    const idx = value.findIndex((b) => b.id === id)
    if (idx === -1) return

    const newBlocks = [...value]
    const swapWith = direction === "up" ? idx - 1 : idx + 1
    if (swapWith < 0 || swapWith >= newBlocks.length) return

    const tmp = newBlocks[idx]
    newBlocks[idx] = newBlocks[swapWith]
    newBlocks[swapWith] = tmp
    onChange(newBlocks)
  }

  const handleRemove = (id: string) => {
    onChange(value.filter((b) => b.id !== id))
  }

  return (
    <div className="mt-6 space-y-4">
      <BlocksToolbar onAddBlock={handleAddBlock} />
      <BlockList blocks={value} onUpdateBlock={handleUpdateBlock} onMove={handleMove} onRemove={handleRemove} />
    </div>
  )
}
